import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkOnboardingStage } from '../features/user/userSlice';
import styles from '../styles/OnboardingFlow.module.css';

export default function WelcomeScreen() {
  const dispatch = useDispatch();
  const onboarding = useSelector(state => state.user.onboarding);
  const features = useSelector(state => state.user.features);
  const isUnderReview = onboarding?.status === 'under-review';

  // Only call refresh manually when user explicitly requests it
  // OnboardingFlow should have already fetched the latest data

  // Log current features for debugging
  useEffect(() => {
    console.log('WelcomeScreen: Current features:', features);
    console.log('WelcomeScreen: Brand under review:', isUnderReview);
  }, [features, isUnderReview]);

  const handleRefresh = () => {
    console.log('WelcomeScreen: Manual refresh triggered');
    dispatch(checkOnboardingStage());
  };

  return (
    <div className={styles.welcomeContainer}>
      <h2>🎉 Welcome to Suspire! 🎉</h2>
      {isUnderReview === true && (
        <div className={styles.banner}>
          <p>⚠️ Your brand is currently under review. You'll receive full access once approved.</p>
          <p><small>Current features: {features?.length || 0} available</small></p>
        </div>
      )}
      {isUnderReview === false && (
        <div className={styles.success}>
          <p>✅ Your onboarding is complete. Enjoy all features!</p>
          <p><small>You now have access to {features?.length || 0} features</small></p>
          {features?.length > 0 && (
            <div className={styles.featuresList}>
              <h4>Available Features:</h4>
              <ul>
                {features.map(feature => (
                  <li key={feature.code}>✓ {feature.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
      
      {/* <div className={styles.refreshSection}>
        <button 
          className={styles.refreshButton} 
          onClick={handleRefresh}
          disabled={onboarding.loading}
        >
          {onboarding.loading ? 'Refreshing...' : '🔄 Refresh Status'}
        </button>
        <p><small>Click to check for any status updates</small></p>
      </div> */}
    </div>
  );
}
